<app-header></app-header>
<div class="container-fluid subheading-2">
  <div class="container bg-one my-5 rounded text-center">
    <h1 class="text-3xl font-semibold pt-20">Add Your Organisation</h1>
    <p class="text-sm  text-zinc-500 pt-3">To get started, you need to enter Organisation name here.</p>
    <div class="mat-card-container pb-20 text-start">
      <mat-card class="shadow">
        <mat-card-content>
          <form [formGroup]="searchOrganizationForm">
            <label for="organization_name" class="block text-gray-700  mb-2 font-semibold text-lg">Name Of
              Organisation</label>
            <input id="organization_name" (blur)="searchOrg()" type="text"
                   class="form-control border border-gray-300 rounded-lg p-3 w-full focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition ease-in-out duration-300"
                   formControlName="organisation_name" placeholder="Enter the name of your organization here">
            <small *ngIf="submitted && searchOrganizationForm.get('organisation_name').hasError('required')"
                   class="text-danger">
              Field is required.
            </small>
            <small class="text-danger py-2" *ngIf="notfoundText">
              Your Organisation Not Registered With us. <span class="text-green-600 cursor-pointer" (click)="gotoUrl('register-org')">Register Now</span>
            </small>
            <div class="py-3">
              <button class="highlight-button bg-[#6752A9] text-white w-full py-2 rounded" type="button"
                      *ngIf="!organization && !orgButton" (click)="gotoUrl('register-org')">
                <i class="fa fa-briefcase"></i> &nbsp; Add Your Organisation
              </button>
              <button class="highlight-button bg-[#6752A9] text-white w-full py-2 rounded" type="button"
                      *ngIf="organization && orgButton" (click)="gotoMain()">
                <i class="fa fa-briefcase"></i> &nbsp; Welcome {{ organization?.organisation }}
              </button>
              <small class="pull-left py-3"><a href="auth/login">Already Organisation is added?</a></small>
            </div>
          </form>
        </mat-card-content>

      </mat-card>
    </div>
  </div>
  <div class="bg-[#6752a9] text-center text-white subheading-2 py-10">
    <h1>Need any further assistance?</h1>
    <h3 class="my-1">Fell free to Reach out for any inquiries or assistance.</h3>
    <button mat-button mat-raised-button class="border-2 my-4">Book an appointment now</button>
  </div>
</div>
<app-footer></app-footer>
